export const vitalCols = [
  {
    title: "Temperature",
    dataIndex: "temperature",
    width: "10%",
  },
  {
    title: "Pulse Rate",
    dataIndex: "pulse",
    width: "10%",
  },
  {
    title: "Respiratory Rate",
    dataIndex: "respiration",
    width: "10%",
  },
  {
    title: "SPO2",
    dataIndex: "oxygen_saturation",
    width: "10%",
  },
  {
    title: "Systolic Pressure",
    dataIndex: "systolic_pressure",
    width: "10%",
  },
  {
    title: "Diastolic Pressure",
    dataIndex: "diastolic_pressure",
    width: "10%",
  },
];
export const grbsCols = [
  {
    title: "GRBS",
    dataIndex: "grbs",
    width: "10%",
  },
  {
    title: "Insulin",
    dataIndex: "insulin",
    width: "10%",
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    width: "10%",
  },
];
export const vitalFormItems = [
  { name: "Temperature", value: "temperature" },
  { name: "Pulse Rate", value: "pulse" },
  { name: "Respiratory Rate", value: "respiration" },
  { name: "SPO2", value: "oxygen_saturation" },
  { name: "Systolic Pressure", value: "systolic_pressure" },
  { name: "Diastolic Pressure", value: "diastolic_pressure" },
];
export const grbsFormItems = [
  { name: "GRBS", value: "grbs" },
  { name: "Insulin", value: "insulin" },
  { name: "Remarks", value: "remarks" },
];
